import MultiSelectDropdown from 'components/ReusableComponents/MultiSelectDropdown'

import filterStyles from '../Common/Filters.module.scss'
import { PEP_CSM_ACTION_FILTER_OPTIONS } from './derivePepCsmAction'
import styles from './PMSandBE.module.scss'

const PepCsmActionFilter = ({ selectedActions, onChangeActions }) => (
  <div className={styles.pepCsmActionFilterControls} aria-label="CSM action filters">
    <span className={styles.alertStatusControlsTitle}>CSM action:</span>
    <MultiSelectDropdown
      className={[filterStyles.statusDropdown, styles.pepCsmActionDropdown].join(' ')}
      itemName="CSM action"
      itemNamePlural="CSM actions"
      value={selectedActions}
      hasUnselectButton
      searchable
      onChangeValue={onChangeActions}
      options={PEP_CSM_ACTION_FILTER_OPTIONS}
    />
  </div>
)

export default PepCsmActionFilter
